import React from "react";
import { useRecoilState } from "recoil";
import { receiptStepState } from "../../recoil/pageStep";
import Button from "../atoms/buttons/Button";
import FooterEmpty from "../modules/layout/FooterEmpty";
import Header from "../modules/layout/Header";
import { logoURL } from "./ApplyRouter";

const ReceiptStartPage = ({ visibility }) => {
	const [receiptStep, setReceiptStep] = useRecoilState(receiptStepState);
	return (
		<>
			<div style={{ display: visibility }}>
				<Header />
				<div className="base-sec">
					<div className="background-color-w">
						<div className="base-sec-top flex">
							<div>
								<p className="title">영어 말하기 평가</p>
							</div>
						</div>
						<div className="base-sec-sec mode-select-sec text-align-center">
							{/*<div className="main_logo">*/}
							<div>
								<img
									className="main_logo_img"
									src="../../../../img/khcp/khcp_logo.png"
									style={{ width: "250px", height: "auto" }}
								/>
							</div>
							<p className="mode-title">
								KHNP 영어 말하기 모의평가
							</p>
							<p className="mode-en">Evaluation of English Speaking for KHNP</p>
							<button
								type="button"
								className="mode-select-btn test-start-btn"
								onClick={() => {
									setReceiptStep(receiptStep + 1);
								}}
							>
								시작하기
							</button>
						</div>
						<FooterEmpty />
					</div>
				</div>
			</div>
		</>
	);
};

export default ReceiptStartPage;
